import Swiper from 'swiper';

const breakpoint = window.matchMedia('(max-width: 767px)');
let aboutValues;
let aboutServices;

const carouselProperties = {
  aboutValuesSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--values',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  aboutServicesSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--services',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  }
};

const aboutSlide = () => { aboutValues = new Swiper('.swiper-container--about', carouselProperties.aboutValuesSlide); };
const servicesSlide = () => { aboutServices = new Swiper('.swiper-container--services', carouselProperties.aboutServicesSlide); };

const breakpointChecker = () => {
  if (breakpoint.matches === false) {
    if (aboutValues !== undefined) {
      aboutValues.destroy(true, true);
      aboutServices.destroy(true, true);
      $('.swiper-pagination--values').html('');
      $('.swiper-pagination--services').html('');
      return;
    }
  } if (breakpoint.matches === true) {
    aboutSlide();
    servicesSlide();
  }
};

breakpoint.addListener(breakpointChecker);

export default breakpointChecker;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/about/aboutSlider.js